import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Typography, Grid, Button } from '@mui/material';
import config from 'src/config';
import { useNavigate } from 'react-router-dom';
import { AuthHeader } from 'src/components/auth/header';
import { AuthFooter } from 'src/components/auth/footer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

class RegisterSuccess extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            type: new URLSearchParams(window.location.search).get('type') || 'personal'
        };
    }

    render() {

        return (
            <>
                <Helmet>
                    <title> Registration Success | {config.APP_NAME} </title>
                </Helmet>

                <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }}>
                    <Grid item xs={12} sm={8} md={5} lg={4} direction={"row"} sx={{ textAlign: 'center' }}>


                        <AuthHeader />

                        <CheckCircleIcon color='primary' sx={{ fontSize: 60, mt: 20 }} />

                        <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
                            You're all set!
                        </Typography>
                        <Typography color="textSecondary" sx={{ mb: 2, fontSize: 12, textAlign: 'center', color: 'gray' }}>
                            {(this.state.type === 'personal') ? (
                                <>
                                    Thank you for registering with dMonk.<br />
                                    We're verifying your signup, you'll receive a confirmation email shortly.<br />
                                    Once verified, you can log in and start using dMonk.
                                </>
                            ) : (
                                <>
                                    Thank you for registering with dMonk.<br />
                                    We're verifying your signup, you'll receive a confirmation email within 24 hours.<br />
                                    Once verified, you can log in and start organizing.
                                </>
                            )}
                        </Typography>

                        <Button
                            variant="contained"
                            onClick={() => {
                                window.location.href = 'https://dmonk.ai';
                            }}
                            xs={12} sm={8} md={5} lg={4}
                            sx={{ mb: 20, justifyContent: 'center' }}
                        >
                            Go to Homepage
                        </Button>

                        <AuthFooter />
                    </Grid>
                </Grid>
                
            </>
        )
    }
}

export default function (props) {
    const navigate = useNavigate();

    return <RegisterSuccess {...props} navigate={navigate} />;
}
